// extracted by mini-css-extract-plugin
export default {"root":"_0UGr","message":"uKkP0"};